/* eslint-disable react/prop-types */
/* eslint-disable arrow-parens */
import { useEffect, useRef, useState, useCallback } from "react";
import * as d3 from "d3";
import { DATA_VISUALIZATION_COLOR_SCHEMA } from "../../../../../../../constants/pieChartColorPalette/PieChartColorPalette";
import { select, svg } from "d3";

import { Grid } from "@material-ui/core";

const _height = window.innerHeight;
const _width = window.innerWidth;

const EnrollmentCountBarChart = ({ data }) => {
	const isBarChartRendered = useRef(false);
	const svgArea = useRef(null);

	const renderBarChart = useCallback(() => {
		const margin = {
			top: 20,
			right: 0,
			bottom: 30,
			left: 40
		};
		// const width = _width;
		// const height = _height;
		const width = 500;
		const height = 300;
		if (isBarChartRendered.current === false) {
			/* x-axis scale generator */
			const x = d3
				.scaleBand()
				.domain(data.map((d) => d.plan_name))
				.rangeRound([margin.left, width - margin.right])
				.padding(0.2);

			/* y-axis scale generator */
			const y = d3
				.scaleLinear()
				.domain([0, d3.max(data, (d) => d.enroll_count)])
				.range([height - margin.bottom, margin.top]);

			/*To create the svg canvas	*/
			const svg = d3.select(svgArea.current).attr("viewBox", [0, 0, width, height]);

			/* Bottom axis or x-axis generator */
			svg.append("g")
				.attr("transform", `translate(0,${height - margin.bottom})`)
				// .attr("transform", "translate(-10,10)rotate(-45)")
				.call(d3.axisBottom(x));
			// .selectAll("text")
			// .attr("transform", "translate(-10,10)rotate(-45)")
			// .style("text-anchor", "end")
			// .style("font-size", 20)
			// .style("fill", "#69a3b2");

			/* Left axis or y-axis generator */
			svg.append("g").attr("transform", `translate(${margin.left},0)`).call(d3.axisLeft(y));

			const colors = [
				DATA_VISUALIZATION_COLOR_SCHEMA.health_plan,
				DATA_VISUALIZATION_COLOR_SCHEMA.clinic_card,
				DATA_VISUALIZATION_COLOR_SCHEMA.group_short_term_disability,
				DATA_VISUALIZATION_COLOR_SCHEMA.group_short_term_visaibility_class_1,
				DATA_VISUALIZATION_COLOR_SCHEMA.group_short_term_visaibility_class_2,
				DATA_VISUALIZATION_COLOR_SCHEMA.hoo,
				DATA_VISUALIZATION_COLOR_SCHEMA.ksop,
				DATA_VISUALIZATION_COLOR_SCHEMA.gLI,
				DATA_VISUALIZATION_COLOR_SCHEMA.ccef
			];

			//Adding Tooltip
			const tooldiv = d3
				.select(".enrollment-count-bar-chart")
				.append("div")
				.attr("class", "each-barchart-tool-div")
				.style("visibility", "hidden")
				.style("padding", "5px 5px")
				// .style("font-size", "16px")
				.style("font-color", "#28a745")
				.style("position", "absolute");

			/* Rendering bar chart according to given data-set */
			svg.append("g")

				.selectAll("rect")
				.data(data)
				.join("rect")
				.attr("fill", function (d, i) {
					return colors[i];
				})
				.attr("opacity", 1)
				.attr("x", (d) => x(d.plan_name))
				.attr("y", (d) => y(d.enroll_count))
				.attr("height", (d) => y(0) - y(d.enroll_count))
				.attr("width", x.bandwidth())
				.on("mouseover", (event, d) => {
					select(event.currentTarget).attr("opacity", 0.7);
					tooldiv.style("visibility", "visible").text(`${d.plan_name}: ` + `${d.enroll_count}`);
					// console.log(d);
					// console.log(event);
				})
				.on("mousemove", (event, d) => {
					tooldiv.style("top", event.pageY - 10 + "px").style("left", event.pageX + 10 + "px");
				})
				.on("mouseout", (event) => {
					// select(event.currentTarget).attr("fill", function (d, i) {
					// 	console.log(colors[i]);
					// 	return colors[i];
					// });
					select(event.currentTarget).attr("opacity", 1);
					// console.log(event.currentTarget);
					tooldiv.style("visibility", "hidden");
				});

			/* Customized x-axis & y-axis */
			const yAxis = (g) =>
				g
					.attr("transform", `translate(${margin.left},0)`)
					.call(d3.axisLeft(y))
					.call((g) => g.select(".domain").remove());

			const xAxis = (g) =>
				g.attr("transform", `translate(0,${height - margin.bottom})`).call(d3.axisBottom(x).tickSizeOuter(0));

			svg.append("g").call(xAxis);

			svg.append("g").call(yAxis);
			isBarChartRendered.current = true;
		}
	}, [data]);

	/* useEffect to implementing pie chart */
	useEffect(() => {
		renderBarChart();
		// renderPieChart();
	}, [renderBarChart]);

	return (
		<Grid container>
			<Grid item xs={6} sm={12} md={12} lg={12} xl={12} className="enrollment-count-bar-chart">
				<svg ref={svgArea}></svg>
			</Grid>
		</Grid>
	);
};

export default EnrollmentCountBarChart;
